//
// Copyright (C) 2024 The Android Open Source Project
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.7.0 with parameter "target=ts,import_extension=none"
// @generated from file android/hardware/automotive/vehicle/SubscribeRequest.proto (package android.hardware.automotive.vehicle.proto, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { SubscribeOptions } from "./SubscribeOptions_pb";
import { file_android_hardware_automotive_vehicle_SubscribeOptions } from "./SubscribeOptions_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file android/hardware/automotive/vehicle/SubscribeRequest.proto.
 */
export const file_android_hardware_automotive_vehicle_SubscribeRequest: GenFile = /*@__PURE__*/
  fileDesc("CjphbmRyb2lkL2hhcmR3YXJlL2F1dG9tb3RpdmUvdmVoaWNsZS9TdWJzY3JpYmVSZXF1ZXN0LnByb3RvEilhbmRyb2lkLmhhcmR3YXJlLmF1dG9tb3RpdmUudmVoaWNsZS5wcm90byJgChBTdWJzY3JpYmVSZXF1ZXN0EkwKB29wdGlvbnMYASABKAsyOy5hbmRyb2lkLmhhcmR3YXJlLmF1dG9tb3RpdmUudmVoaWNsZS5wcm90by5TdWJzY3JpYmVPcHRpb25zYgZwcm90bzM", [file_android_hardware_automotive_vehicle_SubscribeOptions]);

/**
 * @generated from message android.hardware.automotive.vehicle.proto.SubscribeRequest
 */
export type SubscribeRequest = Message<"android.hardware.automotive.vehicle.proto.SubscribeRequest"> & {
  /**
   * @generated from field: android.hardware.automotive.vehicle.proto.SubscribeOptions options = 1;
   */
  options?: SubscribeOptions;
};

/**
 * Describes the message android.hardware.automotive.vehicle.proto.SubscribeRequest.
 * Use `create(SubscribeRequestSchema)` to create a new message.
 */
export const SubscribeRequestSchema: GenMessage<SubscribeRequest> = /*@__PURE__*/
  messageDesc(file_android_hardware_automotive_vehicle_SubscribeRequest, 0);

